import tdisLogo from '../../assets/logos/tdislogo-white.png';
import tamuLogo from '../../assets/logos/TAMUWhiteLogo.svg';
import idrtLogo from '../../assets/logos/idrt-logo.svg';

export const disclaimerConfig = {
  storageKey: 'BA_disclaimer_accepted',
  tdisLogo,
  tamuLogo,
  idrtLogo,
  footerPoweredBy: 'Powered by TDIS',
  welcomeText: 'Welcome to the',
  welcomeTitle: 'Protect property - Buyers Aware',
  informationText:
    'Buyers Aware provides property-specific disaster risk information for potential homebuyers.',
  disclaimerTitle: 'Disclaimer',
  disclaimerText: [
    'By accessing this website or its data, users release Texas A&M University (TAMU) and the Institute for Disaster Resilient Texas (IDRT) from all liability arising from its use. Buyer’s Aware is provided for noncommercial, informational, and planning purposes only. Although efforts are made to ensure accuracy, TAMU and IDRT make no warranties, express or implied, regarding the completeness, reliability, or suitability of the information provided. ',
    'Users are responsible for independently verifying all information before making decisions. TAMU and IDRT do not guarantee continuous or error-free access and may modify or discontinue the tool at any time. The website may include third-party data or links, for which TAMU and IDRT assume no responsibility. ',
    'Use of this tool does not constitute endorsement by any federal, state, or local agency. By using this site, users agree to these terms. '
  ],
  acceptButtonText: 'I Accept'
};